import { create } from 'zustand'
import { auth } from '../../services/firebase'
import { User } from 'firebase/auth'
import { ADMIN_USER_EMAILS } from '../../constants'

interface AuthState {
  user: User | null
  currentUser: User | null // Alias for backward compatibility
  isAdmin: boolean
  loading: boolean
  error: string | null
  signOut: () => Promise<void>
  clearError: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  currentUser: null,
  isAdmin: false,
  loading: true,
  error: null,
  
  signOut: async () => {
    try {
      await auth.signOut()
      set({ user: null, currentUser: null, isAdmin: false })
    } catch (error) {
      set({ error: (error as Error).message })
    }
  },
  
  clearError: () => set({ error: null })
}))

// Initialize the auth listener
auth.onAuthStateChanged((user: User | null) => {
  if (user) {
    useAuthStore.setState({ 
      user: user,
      currentUser: user, 
      isAdmin: ADMIN_USER_EMAILS.includes(user.email || ''),
      loading: false
    })
  } else {
    useAuthStore.setState({ 
      user: null,
      currentUser: null, 
      isAdmin: false,
      loading: false
    })
  }
})
